/**
 * Copyright 2022 Design Barn Inc.
 */

import React from 'react';

export interface ErrorBaseProps {
  action?: React.ReactElement;
  animation?: React.ReactElement;
  details?: React.ReactElement | string;
  title?: React.ReactElement | string;
}

const ErrorBase = (props: ErrorBaseProps): React.ReactElement => {
  const { action, animation, details, title } = props;

  return (
    <div className="m-auto flex max-w-[491px] flex-col items-center p-2">
      <div>{animation}</div>
      <div className="mb-5 w-full text-center text-2xl font-semibold">{title}</div>
      <div className="mb-5 max-w-[385px]">{details}</div>
      <div className="max-w-[280px]">{action}</div>
    </div>
  );
};

export default ErrorBase;
